import React from 'react';
import { HourglassIcon, CameraIcon, ClipboardListIcon, SearchCheckIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { painPoints } from '../../data/content';
const icons = [HourglassIcon, CameraIcon, ClipboardListIcon, SearchCheckIcon];
export function PainSection() {
  return <section aria-labelledby="pain-heading" className="bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-113" data-mp="3m1xldbjy9ggn">
      <div className="mx-auto max-w-5xl" data-id="element-114" data-mp="nhp2yjrkgl42">
        <SectionHeading id="pain-heading" title="Kommt dir das bekannt vor?" data-id="element-115" data-mp="ijx9vmf6qsya" />

        <ul className="mt-12 grid gap-4 sm:grid-cols-2" role="list" data-id="element-116" data-mp="im0af0dys4h9">
          {painPoints.map((pain, index) => {
          const Icon = icons[index];
          return <li key={pain.title} className="flex items-start gap-4 rounded-[20px] bg-brand-ivory p-6" data-id="element-117" data-mp="8tks21yr9dvu" data-mpi={index}>
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-white" data-id="element-118" data-mp="16b2nrw1kfb5y">
                  <Icon className="h-5 w-5 text-brand-forest" strokeWidth={1.5} aria-hidden="true" data-id="element-119" data-mp="11hgiioxqe9k6" />
                </span>
                <span data-id="element-120" data-mp="3gcchve59kruc">
                  <span className="block font-display text-[1.35rem] font-bold leading-tight text-brand-charcoal" data-id="element-121" data-mp="3gcuewczr3a3b">
                    {pain.title}
                  </span>
                  <span className="mt-1.5 block text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-122" data-mp="36mj8mjslgot9">{pain.text}</span>
                </span>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-123" data-mp="2sp4b0rs6taq7">
          Dein Fachwissen ist bereits da. <Accent data-id="element-124" data-mp="2iqex1a3ewaf8">Jetzt braucht dein Unterricht eine klare Struktur.</Accent>
        </p>
      </div>
    </section>;
}